// BOORO: the header every workspace area shares.
import { useLingui } from "@lingui/react/macro";
import { Menu, PanelLeftOpen } from "lucide-react";
import type { ReactNode } from "react";
import { desktopBridge } from "../../lib/desktop";
import { WindowChrome } from "../WindowChrome";

export type WorkspaceChrome = {
  sidebarCollapsed: boolean;
  onOpenNavigation: () => void;
  onRestoreSidebar: () => void;
};

export function WorkspaceViewHeader({
  title,
  chrome,
  actions,
}: {
  title: string;
  chrome: WorkspaceChrome;
  actions?: ReactNode;
}) {
  const { t } = useLingui();
  return (
    <div className="app-drag flex items-center gap-2 border-b border-sidebar-border px-3 py-[17px] md:px-[22px]">
      {chrome.sidebarCollapsed && desktopBridge() ? <WindowChrome /> : null}
      <button
        type="button"
        aria-label={t`Open navigation`}
        onClick={chrome.onOpenNavigation}
        className="app-no-drag grid h-8 w-8 shrink-0 place-items-center rounded-lg text-foreground/75 hover:bg-accent md:hidden"
      >
        <Menu size={19} strokeWidth={1.7} />
      </button>
      {chrome.sidebarCollapsed ? (
        <button
          type="button"
          aria-label={t`Show bots`}
          title={t`Show bots`}
          onClick={chrome.onRestoreSidebar}
          className="app-no-drag hidden h-8 w-8 shrink-0 place-items-center rounded-lg text-foreground/75 hover:bg-accent md:grid"
        >
          <PanelLeftOpen size={19} strokeWidth={1.7} aria-hidden="true" />
        </button>
      ) : null}
      <h1 className="min-w-0 flex-1 truncate text-[16px] font-medium text-foreground">{title}</h1>
      {actions ? <div className="app-no-drag flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
